import request from '@/utils/request';
import Resource from '@/api/resource';
class PromotedObject extends Resource {
  constructor() {
    super('promotedObject/gdt');
  }

  // 获取推广目标
  getPromotedObject(data) {
    return request({
      url: `/${this.uri}`,
      method: 'GET',
      params: data,
    });
  }

  // 更新推广目标
  pullPromotedObject(data){
    return request({
      url: `/${this.uri}/pull`,
      method: 'GET',
      params: data,
    });
  }

  // 新增推广目标
  addPromotedObject(data) {
    return request({
      url: `/${this.uri}`,
      method: 'POST',
      data,
    });
  }
}
export { PromotedObject as default };
